import styled from "styled-components";

const NavigationItemGroup = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export default NavigationItemGroup;